import React from "react";

import { Flex } from "src/components";

import { Input } from "src/components/Form";

import DollarIcon from "react-icons/lib/fa/dollar";

import { colors } from "src/styles";

const AmountInput = props => (
  <Input
    numeric={Boolean(props.value)}
    renderLeftIcon={({ style }) => (
      <Flex {...style}>
        <DollarIcon size={24} color={colors.muted} />
      </Flex>
    )}
    {...props}
  />
);

AmountInput.suppressInlineError = true;

export default AmountInput;



// WEBPACK FOOTER //
// ./src/components/Form/AmountInput.js